'use client'
import React from 'react'
import { TypewriterEffectSmooth } from '@/components/typewriter-effect'
import { cn } from '@/lib/utils'
import { Button } from '@/registry/default/ui/button'
import { useSession } from 'next-auth/react'
import Image from 'next/image'
import { text12px, text16px, text18px, text48px, text9px } from '@/app/utils'
import { useRouter } from 'next/navigation'

interface BentoSectionProps {}

export function BentoSection({}: BentoSectionProps) {
  const { status } = useSession()
  const router = useRouter()

  const wordOnes = [
    {
      text: '全自动AI呼叫中心',
      className: cn(text48px, 'text-primary dark:text-primary'),
    },
  ]
  const wordTwos = [
    {
      text: '线索 / 拨打 / 派单 / 质检',
      className: cn(text48px, 'text-primary dark:text-primary'),
    },
  ]
  const wordThrees = [
    {
      text: 'AI全面接管',
      className: cn(text48px, 'text-primary dark:text-primary'),
    },
  ]

  return (
    <div className={cn('container px-0 relative')}>
      <div className={cn('grid w-full md:flex md:justify-between py-5')}>
        <div
          className={cn(
            'flex flex-col w-full md:w-[50%] items-center md:items-start justify-center md:h-[30rem] xl:h-[40rem] h-[24rem] space-y-4 md:px-0'
          )}
        >
          <TypewriterEffectSmooth words={wordOnes} hiddenCursor={true} />
          <TypewriterEffectSmooth words={wordTwos} hiddenCursor={true} />
          <TypewriterEffectSmooth words={wordThrees} />
          <div className={cn(text16px, 'mb-4 md:px-1')}>
            突破人工业务瓶颈，精细运营，稳定转化，收入翻倍。
          </div>
          <div
            className={cn(
              'flex items-center justify-center md:justify-start w-full space-x-4'
            )}
          >
            <Button
              className={cn(
                text16px,
                'bg-[#444BD3] w-[124px] h-[52px] rounded-[6px]'
              )}
              onClick={() => {
                status === 'authenticated'
                  ? router.push(`/dashboard`)
                  : router.push('/register')
              }}
            >
              申请试用
            </Button>
            {/*<Link*/}
            {/*  passHref*/}
            {/*  rel={'noreferrer'}*/}
            {/*  target={'_blank'}*/}
            {/*  href={*/}
            {/*    status === 'authenticated'*/}
            {/*      ? `/answer`*/}
            {/*      : { pathname: `/login`, query: { role: 'expert' } }*/}
            {/*  }*/}
            {/*  className={cn(*/}
            {/*    buttonVariants({ variant: 'default', size: 'lg' })*/}
            {/*  )}*/}
            {/*>*/}
            {/*  <Icons.tailwind className={cn('mr-2 h-4 w-4')} />*/}
            {/*  申请试用*/}
            {/*</Link>*/}
          </div>
        </div>
        {/*<div*/}
        {/*  className={cn(*/}
        {/*    'absolute pointer-events-none inset-0 flex items-center justify-center dark:bg-background bg-background [mask-image:radial-gradient(ellipse_at_center,transparent_60%,black)]'*/}
        {/*  )}*/}
        {/*/>*/}
        <div
          style={{
            backgroundImage:
              'radial-gradient(circle, #F2F2F5 1px, transparent 1px)',
            backgroundSize: '10px 10px',
          }}
          className="w-full md:w-[70%] flex flex-col space-y-5 p-10"
        >
          <div className={cn('w-full flex justify-between')}>
            <div className={cn('flex rounded-[4px] bg-white p-8')}>
              <div className={cn('flex flex-col space-y-3 w-full')}>
                <div className={cn(text9px, 'font-bold')}>成本下降</div>
                <div className={cn(text18px, 'font-bold')}>85%</div>
                <Image
                  alt={'design'}
                  src={'/home/cb.svg'}
                  width={160}
                  height={160}
                  className={cn('object-cover')}
                />
              </div>
            </div>
            <div className={cn('flex rounded-[4px] bg-white p-8')}>
              <div className={cn('flex flex-col space-y-3 w-full')}>
                <div className={cn(text9px, 'font-bold')}>产出提升</div>
                <div className={cn(text18px, 'font-bold')}>300%</div>
                <Image
                  alt={'design'}
                  src={'/home/cc.svg'}
                  width={160}
                  height={160}
                  className={cn('object-cover')}
                />
              </div>
            </div>
            <div className={cn('flex rounded-[4px] bg-white p-8')}>
              <div className={cn('flex flex-col space-y-3 w-full')}>
                <div className={cn(text9px, 'font-bold')}>风险降低</div>
                <div className={cn(text18px, 'font-bold')}>95%</div>
                <Image
                  alt={'design'}
                  src={'/home/fx.svg'}
                  width={160}
                  height={160}
                  className={cn('object-cover')}
                />
              </div>
            </div>
          </div>
          <div className={cn('w-full px-10')}>
            <Image
              alt={'design'}
              src={'/home/line.svg'}
              width={460}
              height={160}
              className={cn('w-full object-cover')}
            />
          </div>
          <div className={cn('w-full flex justify-between px-12')}>
            <div className={cn('flex items-start justify-center')}>
              <div className={cn('flex flex-col items-center gap-4 w-full')}>
                <div className={cn(text9px, 'text-[#444BD3] font-bold')}>
                  数据
                </div>
                <Image
                  alt={'design'}
                  src={'/home/data.svg'}
                  width={180}
                  height={180}
                  className={cn('object-cover')}
                />
              </div>
            </div>
            <div className={cn('flex rounded-[4px] bg-white p-5')}>
              <div className={cn('flex flex-col space-y-3 w-full')}>
                <div className={cn(text12px, 'w-full text-center font-bold')}>
                  AI员工调度
                </div>
                <div className={cn('w-full bg-[#F2F2F5] h-[1px]')} />
                <Image
                  alt={'design'}
                  src={'/home/dd.svg'}
                  width={180}
                  height={180}
                  className={cn('object-cover')}
                />
              </div>
            </div>
            <div className={cn('flex items-start justify-center')}>
              <div className={cn('flex flex-col items-center gap-4 w-full')}>
                <div className={cn(text9px, 'text-[#444BD3] font-bold')}>
                  工作流
                </div>
                <Image
                  alt={'design'}
                  src={'/home/flow.svg'}
                  width={160}
                  height={160}
                  className={cn('object-cover')}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
